import React from 'react'

import InstagramSvg from './../../graphics/instagram.svg'
import FacebookSvg from './../../graphics/facebook.svg'
import TwitterSvg from './../../graphics/twitter.svg'
import MailSvg from './../../graphics/mail.svg'
import LinkedInSvg from './../../graphics/linkedin.svg'

import styles from './styles.module.scss'

const Socials = ({ className, items, showEmail }) => {
    return (
        <ul className={className}>
            {items && items.map((item, i) => {
                return (
                    <li key={i} className={styles['social__list-item']}>
                        <a className={styles['social__link']} href={item.link.linktype == 'email' ? `mailto:${item.link.email}` : item.link.url} target={item.link.linktype == 'email' ? '_self' : '_blank'}>
                            {item.type == 'mail' && <MailSvg className={`${styles['social__icon']} ${styles['social__icon--mail']}`} />}
                            {item.type == 'linkedin' && <LinkedInSvg className={`${styles['social__icon']} ${styles['social__icon--linkedin']}`} />}
                            {item.type == 'instagram' && <InstagramSvg className={`${styles['social__icon']} ${styles['social__icon--instagram']}`} />}
                            {item.type == 'facebook' && <FacebookSvg className={`${styles['social__icon']} ${styles['social__icon--facebook']}`} />}
                            {item.type == 'twitter' && <TwitterSvg className={`${styles['social__icon']} ${styles['social__icon--twitter']}`} />}
                        </a>
                    </li>
                )
            })}
        </ul>
    )
}

export default Socials
